import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faCalendarClock } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import { CreateEditJobTypesModal } from 'pos-client/components/locations/manage-job-types/CreateEditJobTypeModal.tsx';
import { SearchJobTypes } from 'pos-client/components/locations/manage-job-types/SearchJobTypes.tsx';
import { PosCard } from 'pos-client/components/shared/Display/Card/PosCard.tsx';
import { usePermissions } from 'pos-client/hooks/usePermissions.tsx';
import { PosPageContent } from 'pos-client/layouts/page/PosPageContent.tsx';
import type { JobTypeModel } from 'pos-shared/models/jobTypeSchema.ts';

export const ManageJobTypesPage = () => {
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editJobType, setEditJobType] = useState<JobTypeModel | null>(null);
  const { hasPermissions } = usePermissions();

  const canAddJobType = hasPermissions('add.edit.job.types');

  const handleEditJobType = (jobType: JobTypeModel) => {
    setEditJobType(jobType);
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    setEditJobType(null);
    setModalIsOpen(false);
  };

  return (
    <>
      <PosPageContent>
        <PosCard
          headerProps={{
            title: t('jobTypes.manageJobTypes'),
            icon: faCalendarClock,
            description: t('jobTypes.pageDescription'),
            action: canAddJobType && (
              <Button type="primary" onClick={() => setModalIsOpen(true)}>
                <FontAwesomeIcon icon={faPlus} />
                {t('jobTypes.createJobType')}
              </Button>
            ),
          }}
        >
          <SearchJobTypes handleEditJobType={handleEditJobType} />
        </PosCard>
      </PosPageContent>
      {modalIsOpen && (
        <CreateEditJobTypesModal
          modalIsOpen={modalIsOpen}
          handleModalClose={handleModalClose}
          jobType={editJobType}
          isEdit={!!editJobType}
        />
      )}
    </>
  );
};
